import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
    static targets = ["submitButton", "singleUseToken"]

    initialize() {
        this._frame = null;
    }

    static values = {
        publishableApiKey: String,
        source: String,
        frame: String
    }

    connect() {
        switch (this.sourceValue) {
            case 'credit_card':
                this._createCreditCardFrame();
                break;
            case 'bank_account':
                this._createBankAccountFrame();
                break;
            default:
                console.error('Invalid source');
                this.submitButtonTarget.disabled = false;
        }
    }

    async submit(event) {
        event.preventDefault(); 
        this.submitButtonTarget.disabled = true; 

        try {
            await this._setSingleUseToken();
            this.element.requestSubmit();
        } catch (error) {
            this.submitButtonTarget.disabled = false;
        }
    }

    _createCreditCardFrame() {
        payway.createCreditCardFrame({
            publishableApiKey: this.publishableApiKeyValue,
            onValid: () => { this.submitButtonTarget.disabled = false; },
            onInvalid: () => { this.submitButtonTarget.disabled = true; },
            container: this.frameValue,
            tokenMode: 'callback'
        }, this._createdCallback.bind(this));
    }

    _createBankAccountFrame() {
        payway.createBankAccountFrame({
            publishableApiKey: this.publishableApiKeyValue,
            onValid: () => { this.submitButtonTarget.disabled = false; },
            onInvalid: () => { this.submitButtonTarget.disabled = true; },
            container: this.frameValue,
            tokenMode: 'callback'
        }, this._createdCallback.bind(this));
    }

    _createdCallback(err, frame) {
        if (err) {
            console.error(err);
        } else {
            this.frame = frame;
        }
    }

    get frame() {
        return this._frame;
    }

    set frame(value) {
        this._frame = value;
    }

    _setSingleUseToken() {
         return new Promise((resolve, reject) => {
            if (this.frame) {
                this.frame.getToken((err, data) => {
                    if (err) {
                        console.error(err);
                        reject(err);
                    } else {
                        this.singleUseTokenTarget.value = data.singleUseTokenId;
                        resolve();
                    }
                });
            } else {
                reject(new Error("Frame not initialized"));
            }
        });
    }

}
